import { ArcStack, ArcText } from "@src/core/ui";
import React from "react";
import { VARIANT_NO_FLY, VARIANT_SAFE_LAND, ZoneItemProps } from '@src/features/zones/pages/zones-page/types';
import { useDispatch } from "react-redux";
import { setHoveredSafeLandZoneId, setSelectedZone } from "@src/features/zones/redux";
import { setHoveredNoFlyZoneId } from '@src/core/features/zones/redux';
import { setMapCenter } from "@src/core/controllers";
import { arcToFixed } from "@src/core/extensions";


export const ZoneItem: React.FC<ZoneItemProps> = (props) => {
  const { zone, isSelected = false, variant } = props;

  const dispatch = useDispatch();
    
  const onSelect = () => {
    dispatch(setMapCenter({ lat: Number(zone.centerLatitude), lng: Number(zone.centerLongitude) }));
    dispatch(setSelectedZone(zone));
  };

  const safeLandHoverProps =
    variant === VARIANT_SAFE_LAND
      ? {
        onMouseEnter: () => {
          dispatch(setHoveredSafeLandZoneId(zone.id));
        },
        onMouseLeave: () => {
          dispatch(setHoveredSafeLandZoneId(null));
        },
      }
      : {};

  const noFlyHoverProps =
    variant === VARIANT_NO_FLY
      ? {
        onMouseEnter: () => {
          dispatch(setHoveredNoFlyZoneId(zone.id));
        },
        onMouseLeave: () => {
          dispatch(setHoveredNoFlyZoneId(null));
        },
      }
      : {};

  const listHoverProps = { ...safeLandHoverProps, ...noFlyHoverProps };

  const zoneValue = variant === VARIANT_SAFE_LAND ? zone.altitudeMeters : zone.areaSquareMeters;
  const zoneValueLabel = variant === VARIANT_SAFE_LAND ? 'm' : 'm²';
  return (
    <ArcStack padding={1} direction="row" justifyContent="space-between" 
      sx={{
        cursor: "pointer",
        bgcolor: "grey.900",
        borderRadius: '4px',
        "&:hover": {
          bgcolor: "grey.800",
        },
        border: "1px solid",
        borderColor: isSelected
          ? "brand.main"
          : "grey.900",
        padding: '7px 15px',
        textAlign: 'center',
        alignItems: 'center',
      }}
      onClick={onSelect}
      {...listHoverProps}
    >  
      <ArcText.button sx={{ border: "1px solid", borderColor: "grey.500", padding: '1px 7px', borderRadius: '4px', opacity: zone.isActive ? 1 : 0.3, }}> {zone.name} </ArcText.button>
      <ArcText.h6 sx={{ opacity: zone.isActive ? 1 : 0.3,  fontWeight: 400, fontSize: 12 }}> {arcToFixed(zoneValue)} {zoneValueLabel}</ArcText.h6>
    </ArcStack>
  );
};